import axios from '../../axios'
import qs from 'qs';

/* 
 * 用户模块
 */

// 登录
export const login = (data) => {
	data = qs.stringify(data);
	return axios({
		url: '/user/login.php',
		method: 'post',
		data
	});
}

// 获取用户信息
export const getUserInfo = (token) => {
	return axios({
		url: '/user/info.php',
		method: 'get',
		params: { token }
	})
}

// 注册
export const signup = (data) => {
	data = qs.stringify(data);
	return axios({
		url: '/user/signup.php',
		method: 'post',
		data
	})
}

// 登出
export const logOut = (data) => {
	return axios({
		url: '/user/logout.php',
		method: 'get',
	})
}
